import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IDataColumn} from '../../interfaces/data-column.interface';
import { IFilterItem } from '../../interfaces/filter-item.interface';
import { FilterType } from '../../interfaces/filter-type.enum';
import { endOfDay, getUnixTime, isAfter, isBefore, startOfDay } from 'date-fns';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'app-dynamic-filters',
  templateUrl: './dynamic-filters.component.html',
  styleUrls: ['./dynamic-filters.component.scss']
})
export class DynamicFiltersComponent implements OnInit {

  @Input() datacolumns: IDataColumn[] = [];
  @Input() datavalues: any[] = [];
  @Output() filteredValuesChange: EventEmitter<any[]> = new EventEmitter<any[]>();

  public filters: Array<IFilterItem> = [];
  public selectedFilters: any[] = [];
  public filtersLoading = false;

  public initialSelection: any[] = [];
  public selection: any[] = []
  private filteredValues: any[] = [];

  constructor(private config: PrimeNGConfig) { }

  ngOnInit() {
    this.generateFilters();
    this.config.setTranslation({
      clear: 'Borrar',
      today: 'Hoy',
      firstDayOfWeek: 1,
      dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
      monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
      monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun","Jul", "Ago", "Sep", "Oct", "Nov", "Dic"]
    });
  }

  resetFilters(){
    this.selection = this.initialSelection;
    this.filteredValues = JSON.parse(JSON.stringify(this.datavalues));
    this.filteredValuesChange.emit(this.filteredValues);
  }

  generateFilters(){
    let filterIndex: number = 0;
    this.datacolumns = this.datacolumns.filter(column => column.filterable).sort((a, b) => {
      return a.filterOrder! - b.filterOrder!;
    });
    this.datacolumns.forEach((column: IDataColumn) => {
      const filterItem: IFilterItem = {column: column.field, name: column.value, type:column.filterType!, options: [] as Array<any>};
      if(column.filterType === FilterType.SINGLE){
        this.selection[filterIndex] = [];
        this.datavalues.forEach((value: any) => {
          if(!filterItem.options.includes(value[column.field!])){
            filterItem.options.push(value[column.field!]);
          }
        });
      }
      if(column.filterType === FilterType.MULTIPLE){
        this.selection[filterIndex] = [];
        this.datavalues.forEach((value: any) => {
          if(!filterItem.options.includes(value[column.field!])){
            filterItem.options.push(value[column.field!]);
            this.selection[filterIndex].push(value[column.field!])
          }
        });
      }
      if(column.filterType === FilterType.RANGE){
        const values = this.datavalues.map((value: any) => value[column.field!]);
        filterItem.options = [Math.min(...values), Math.max(...values)];
        this.selection[filterIndex] = [Math.min(...values), Math.max(...values)];
      }
      if(column.filterType === FilterType.DATERANGE){
        const values = this.datavalues.map((value: any) => getUnixTime(value[column.field!]));
        filterItem.options = [new Date(Math.min(...values) * 1000), new Date(Math.max(...values) * 1000)];
        this.selection[filterIndex] = [new Date(Math.min(...values) * 1000), new Date(Math.max(...values) * 1000)];
      }
      this.filters.push(filterItem);
      filterIndex++;
    });
    this.initialSelection = JSON.parse(JSON.stringify(this.selection));
    this.filteredValues = JSON.parse(JSON.stringify(this.datavalues));
  }

  today(): Date {
    return new Date();
  }

  processChange(){
    this.filteredValues = this.datavalues.filter((element: any) => {
      let match: boolean = true;
      for (let [index, filter] of this.filters.entries()) {
        if (filter.type !== FilterType.RANGE && filter.type !== FilterType.DATERANGE) {
          match = this.selection[index].includes(element[filter.column!]);
        }
        if(filter.type === FilterType.DATERANGE){
          match = isAfter(startOfDay(element[filter.column!]), startOfDay(this.selection[index][0]))
                  && isBefore(endOfDay(element[filter.column!]), endOfDay(this.selection[index][1]));
        }
        if (filter.type == FilterType.RANGE) {
          match = element[filter.column!] >= this.selection[index][0] && element[filter.column!] <= this.selection[index][1];
        }
        if (!match) {
          break;
        }
      }
      return match;
    });
    this.filteredValuesChange.emit(this.filteredValues);
  }

}
